module.exports = __webpack_public_path__ + "static/img/support_5.dc3c8be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/support_5.png
// module id = 2A8F
// module chunks = 0